import { render } from "./AvDosya_Edit.vue?vue&type=template&id=12f2fba5"
import script from "./AvDosya_Edit.vue?vue&type=script&lang=js"
export * from "./AvDosya_Edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__